/** Hands a blob to the browser as a download with the given filename. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.hidden = true;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoking early can cancel the download. Parts after the first may wait on the browser's
  // "allow multiple downloads?" prompt, which the user may answer minutes later.
  setTimeout(() => URL.revokeObjectURL(url), 10 * 60_000);
}
